// extracted by mini-css-extract-plugin
export default {"root":"ClientPanelFooter_root__WKH0D","button":"ClientPanelFooter_button__5IyMq","wrapper":"ClientPanelFooter_wrapper__3WlzW","edit":"ClientPanelFooter_edit__LQ5p7"};